module.exports = fox._r("fonts/ostrich-sans-black.ttf", __webpack_public_path__ + "_/_/_/root/fonts/3g5NlmQ.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-black.ttf
// module id = 154
// module chunks = 4